import React from "react";
import { ListItem } from "@material-ui/core";
import { useSelector } from "react-redux";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));
const AvailableProductsFilter = ({
  availableProducts,
  setAvailableProducts,
}) => {
  const classes = useStyles();
  //REDUX
  const themeColor = useSelector((state) => state.store.store.settings?.dark);
  const language = useSelector((state) => state.store.language);

  const handleSelectFilter = () => {
    setAvailableProducts(!availableProducts);
  };

  return (
    <>
      <ListItem
        button
        onClick={handleSelectFilter}
        style={{
          paddingLeft: language === "arabic" ? "" : 0,
          paddingRight: language === "arabic" ? 0 : "",
          marginTop: 15,
          direction: language === "arabic" ? "rtl" : "ltr",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: "26px",
              width: "6px",
              backgroundColor:
                availableProducts ? themeColor : "transparent",
            }}
          ></div>
          <span
            style={{
              flex: 1,
              marginLeft: language === "arabic" ? 0 : 16,
              marginRight: language === "arabic" ? 16 : 0,
              fontWeight: "bold",
              fontSize: "15px",
              textAlign: language === "arabic" ? "right" : "left",
            }}
          >
            {language === "arabic" ? "المنتجات المتاحة" : "Available Products"}
          </span>
          {availableProducts && (
            <FiberManualRecordIcon
              style={{
                fontSize: 14,
                color: themeColor,
                marginRight: language === "arabic" ? 0 : 4,
                marginLeft: language === "arabic" ? 4 : 0,
              }}
            />
          )}
        </div>
      </ListItem>
    </>
  );
};

export default AvailableProductsFilter;
